<template>
  <div>
    <Comp_choice v-if="!selectedComponent" @select-component="updateComponent"></Comp_choice>
    <component :is="selectedComponent"></component>
    <!-- <Comp_CompetitionAdd></Comp_CompetitionAdd> -->
  </div>
</template>

<script>
import Comp_choice from '../components/AddChoice.vue';
import Comp_CompetitionAdd from '../components/AddCompetition.vue';
import Comp_CompetitionAddOT from '../components/AddOTCompetition.vue';

export default {
  name: 'Competition',
  components: {
    Comp_choice,
    Comp_CompetitionAdd,
    Comp_CompetitionAddOT
  },
  data() {
    return {
      selectedComponent: false
    };
  },
  methods: {
    updateComponent(component) {
      console.log("this.selectedComponent", this.selectedComponent);
      this.selectedComponent = component;
      console.log("this.selectedComponent", this.selectedComponent);
    }
  }
}
</script>
